module.exports = __webpack_public_path__ + "img/brandmeLogo-provicional-dark.1941dd74.png";